import * as React from "react";
const SvgMoveDown = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="#000" d="M14.667 4v8H20l-8 8-8-8h5.333V4z" /></svg>;
export { SvgMoveDown as ReactComponent };